/* eslint-disable object-curly-newline */
import React, { useState, useEffect, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import getComments from '../../../api/graphql/queries/getComments';
import commentRemove from '../../../api/graphql/mutations/commentRemove';

import Filter from '../../Tabs/Filter';
import CommentsTable from './CommentsTable';
import Toolbar from './CommentsToolbar';
// import CommentsForm from './CommentsForm';
import CommentsFormOnlyShow from './CommentsFormOnlyShow';
import Modal from '../../Modal/Modal';
import LoadIcon from '../../LoadIcon';

const CommentsContainer = () => {
  const [filteredData, setFilteredData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [isCreateModalOn, setIsCreateModalOn] = useState(false);
  const [isDisplayModalOn, setIsDisplayModalOn] = useState(false);
  const [isModifyModalOn, setIsModifyModalOn] = useState(false);
  const [isDeleteModalOn, setIsDeleteModalOn] = useState(false);
  const [formOutput, setFormOutput] = useState({});
  const [currItemData, setCurrItemData] = useState([]);
  const [toggleDeleteInfoScreen, setToggleDeleteInfoScreen] = useState([]);
  const [total, setTotal] = useState(0);
  const [query, setQuery] = useState('');
  const [reloadData, setReloadData] = useState(false);

  // Filtering items:
  const [commentId, setCommentId] = useState(null);
  const [postSlugName, setPostSlugName] = useState(null);
  const [userId, setuserId] = useState(null);
  const [nickname, setNickname] = useState(null);
  const [commentText, setCommentText] = useState(null);
  const [createdAt, setCreatedAt] = useState(null);
  const [hasBadge, setHasBadge] = useState(null);
  const [deleted, setDeleted] = useState(null);
  const [censored, setCensored] = useState(null);
  const [searchPostSlugName, setSearchPostSlugName] = useState(null);
  const [searchCommentText, setSearchCommentText] = useState(null);
  const [searchNickname, setSearchNickname] = useState(null);
  const [startDate, setStartDate] = useState(null);
  const [finishDate, setFinishDate] = useState(null);

  // Sorting items:
  const [sorting, setSorting] = useState(['createdAt', -1]);

  // Pagination
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(50);
  const [previousPage, setPreviousPage] = useState(0);
  const [avoidEffect, setAvoidEffect] = useState(false);

  // const deleteComment = (event) => {
  //   console.log('Delete comment', event.currentTarget.id);
  // };

  const censoreComment = async (event) => {
    const { currentTarget: { id, attributes: { 'data-deleted': { value: deletedComment } = {} } } } = event;
    console.log('Censore comment', id);
    if (deletedComment === 'true') {
      // eslint-disable-next-line no-alert
      if (window.confirm('¿Restore comment?')) {
        const res = await commentRemove({ commentId: id, restore: true });
        if (res) {
          setReloadData(new Date());
        }
      }
      return;
    }

    // eslint-disable-next-line no-alert
    if (window.confirm('Censore comment?')) {
      const res = await commentRemove({ commentId: id });
      if (res) {
        setReloadData(new Date());
      }
    }
  };

  const columns = [
    { field: 'commentId', headerName: 'commentId', type: 'string', sortable: true, align: 'left', hide: true, isId: true },
    { field: null, headerName: '', type: 'action', align: 'left', content: ((rowData, idValue) => (<span id={idValue} data-deleted={rowData.deleted} className={`font-icon icon-trash text-20 ${rowData.deleted ? 'text-blue' : 'text-red'}`} onClick={censoreComment} title="Censore comment" />)) },
    { field: 'postSlugName', headerName: 'postSlugName', type: 'string', sortable: true, align: 'left' },
    // { field: 'userId', headerName: 'userId', type: 'string', sortable: true, align: 'left' },
    { field: 'email', headerName: 'email', type: 'string', sortable: true, align: 'left' },
    { field: 'nickname', headerName: 'nickname', type: 'string', sortable: true, align: 'left' },
    { field: 'commentText', headerName: 'commentText', type: 'string', sortable: true, align: 'left', conditionalClassName: (rowData => (rowData.deleted && 'line-through')) },
    { field: 'createdAt', headerName: 'createdAt', type: 'date', sortable: true, align: 'left' },
    // { field: 'hasBadge', headerName: 'hasBadge', type: 'boolean', sortable: true, align: 'left' },
    { field: 'deleted', headerName: 'deleted', type: 'boolean', sortable: true, align: 'left' },
    { field: 'censored', headerName: 'censored', type: 'boolean', sortable: true, align: 'left' },
  ];

  useEffect(() => {
    if (avoidEffect) {
      console.log('Avoiding effect');
      return;
    }
    let from = page * rowsPerPage;
    let to = (page + 1) * rowsPerPage;
    if (previousPage === page) {
      setAvoidEffect(true);
      setPage(0);
      from = 0;
      to = rowsPerPage;
    } else {
      from = page * rowsPerPage;
      to = (page + 1) * rowsPerPage;
      setPreviousPage(page);
    }
    console.log('Calling getComments()');
    getComments({
      commentId,
      postSlugName,
      userId,
      nickname,
      commentText,
      createdAt,
      hasBadge,
      deleted,
      censored,
      searchPostSlugName,
      searchCommentText,
      searchNickname,
      startDate,
      finishDate,
      from,
      to,
      sortingField: sorting[0],
      sortingType: sorting[1],
    }).then((commentsDataObject) => {
      if (commentsDataObject) {
        if (commentsDataObject.isAuth) {
          setTotal(commentsDataObject.total);
          setQuery(commentsDataObject.query);
          setFilteredData(commentsDataObject.comments);
          setIsLoading(false);
        } else {
          console.log('getComments failed!');
        }
      } else {
        console.log('commentsData = null');
      }
      setAvoidEffect(false);
    });
  }, [
    commentId,
    postSlugName,
    userId,
    nickname,
    commentText,
    createdAt,
    hasBadge,
    deleted,
    censored,
    searchPostSlugName,
    searchCommentText,
    searchNickname,
    startDate,
    finishDate,
    page,
    rowsPerPage,
    sorting,
    reloadData,
  ]);

  // const updateSearch = (val) => {
  //   setFilterText(val);
  //   setFilteredData(initialItems.filter(item => item.email.toLowerCase().includes(val.toLowerCase())));
  // };

  const toggleCreateModal = () => {
    setIsCreateModalOn(!isCreateModalOn);
  };

  const toggleDisplayModal = (item) => {
    setIsDisplayModalOn(!isDisplayModalOn);
    setCurrItemData(filteredData.find(el => el._id === item));
  };

  const toggleModifyModal = (item) => {
    setIsModifyModalOn(!isModifyModalOn);
    setCurrItemData(filteredData.find(el => el._id === item));
  };

  const toggleDeleteModal = (item) => {
    setIsDeleteModalOn(!isDeleteModalOn);
    setCurrItemData(filteredData.find(el => el._id === item));
  };

  const formOutputHandler = (value) => {
    setFormOutput(value);
    // we would send this to the DB to create an entry
  };

  const handleClick = (action, item) => {
    switch (action) {
      case 'create':
        toggleCreateModal();
        break;
      case 'display':
        toggleDisplayModal(item);
        break;
      case 'modify':
        toggleModifyModal(item);
        break;
      case 'delete':
        toggleDeleteModal(item);
        break;
      case 'closeDeleteItem':
        setToggleDeleteInfoScreen(!toggleDeleteInfoScreen);
        break;
      default:
        console.log('wrong action!');
        break;
    }
  };

  return (
    <Fragment>
      <div className="w-full bg-white">
        <div className="flex justify-between mb-4">
          <span className="text-americaMonoBold text-26">Comments</span>
          <span className="font-americaMonoBold text-14 uppercase">
            Total:
            {total}
          </span>
          {/* <button
            type="button"
            className="font-americaMonoBold text-xs px-6 rounded-full bg-black text-white uppercase"
            onClick={() => {
              handleClick('create');
            }}
          >
            Create User
          </button> */}
        </div>
        {isDisplayModalOn && (
          <Modal title="Display Comment" handleClick={handleClick} type="display">
            <CommentsFormOnlyShow handleClick={handleClick} formInput={currItemData} action="display" />
          </Modal>
        )}
        <div className="mt-4">
          {!isLoading ? (
            <>
              <Toolbar
                // setHasBadge={setHasBadge}
                deleted={deleted}
                setDeleted={setDeleted}
                censored={censored}
                setCensored={setCensored}
                setSearchPostSlugName={setSearchPostSlugName}
                setSearchCommentText={setSearchCommentText}
                setSearchNickname={setSearchNickname}
                setStartDate={setStartDate}
                setFinishDate={setFinishDate}
              />
              <CommentsTable
                tableData={filteredData}
                columns={columns}
                // handleClick={handleClick}
                total={total}
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                sorting={sorting}
                setSorting={setSorting}
              />
              <div style={{ color: '#fff' }}>
                {query}
              </div>
            </>
          ) : <LoadIcon />}
        </div>
      </div>
    </Fragment>
  );
};

CommentsContainer.propTypes = {
};

export default withRouter(CommentsContainer);
